<div class="card">
  <div class="card-content">
    @if (loading) {
      <div class="portfolio-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading portfolio metrics...</span>
      </div>
    } @else {
      <div class="portfolio-kpi-row">
        @for (card of cards; track card.label) {
          <div
            class="stats-card stats-card--interactive"
            [ngClass]="[card.styleClass, isCardSelected(card) ? 'stats-card--selected' : '']"
            role="button"
            tabindex="0"
            (click)="onKpiCardClick(card)"
            (keydown.enter)="onKpiCardClick(card)"
            (keydown.space)="onKpiCardClick(card); $event.preventDefault()">
            <div class="stats-card-main">
              <span class="stats-card-label">{{ card.label }}</span>
              <span class="stats-card-value">{{ card.value }}</span>
              <span class="stats-card-sublabel">{{ card.sublabel }}</span>
            </div>
            <div class="stats-card-icon">
              <i [class]="card.icon"></i>
            </div>
          </div>
        }
      </div>

      <div class="portfolio-dashboard-grid">
        <section class="portfolio-panel portfolio-panel--charts">
          <article class="chart-card">
            <div class="panel-header">
              <h3>Status Breakdown</h3>
            </div>
            <div class="chart-shell">
              <p-chart
                type="doughnut"
                [data]="statusChartData"
                [options]="statusChartOptions"
                (onDataSelect)="onStatusChartSelect($event)"></p-chart>
            </div>
          </article>

          <article class="chart-card">
            <div class="panel-header">
              <h3>Projects by Service Group</h3>
            </div>
            <div class="chart-shell">
              <p-chart
                type="doughnut"
                [data]="serviceGroupChartData"
                [options]="statusChartOptions"
                (onDataSelect)="onServiceGroupChartSelect($event)"></p-chart>
            </div>
          </article>

          <article class="chart-card">
            <div class="panel-header">
              <h3>Projects by Manager</h3>
            </div>
            <div class="chart-shell">
              <p-chart
                type="doughnut"
                [data]="managerChartData"
                [options]="statusChartOptions"
                (onDataSelect)="onManagerChartSelect($event)"></p-chart>
            </div>
          </article>
        </section>

        <section class="portfolio-panel portfolio-panel--table portfolio-panel--full-width">
          <div class="panel-header panel-header--with-actions">
            <h3>Active Projects - Health Summary</h3>
            @if (hasActiveFilter()) {
              <div class="active-filter-chip">
                <span>{{ getActiveFilterLabel() }}</span>
                <button type="button" class="clear-filter-btn" (click)="clearFilter()">Clear</button>
              </div>
            }
          </div>

          <div class="table-shell">
            <p-table
              [value]="healthRows"
              [scrollable]="true"
              scrollHeight="flex"
              [tableStyle]="{ 'min-width': '100%' }"
              styleClass="p-datatable no-column-lines compact-striped-table portfolio-health-table fill-height">
              <ng-template pTemplate="header">
                <tr>
                  <th class="th-project">Project</th>
                  <th>Client</th>
                  <th>Manager</th>
                  <th>Service Group</th>
                  <th class="th-progress">Progress</th>
                  <th>Status</th>
                  <th>End Date</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr>
                  <td class="td-project">
                    <div class="project-cell">
                      <span class="project-code">{{ row.projectCode }}</span>
                      <span class="project-name">{{ row.projectName }}</span>
                    </div>
                  </td>
                  <td>{{ row.clientName }}</td>
                  <td>{{ row.managerName }}</td>
                  <td>{{ row.serviceGroupName }}</td>
                  <td class="td-progress">
                    <div class="progress-cell">
                      <span class="progress-label">{{ row.progressLabel }}</span>
                      <div class="progress-track">
                        <div class="progress-fill" [style.width.%]="row.progressPercent"></div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="status-pill" [ngClass]="row.statusClass">{{ row.statusLabel }}</span>
                  </td>
                  <td>{{ row.endDateLabel }}</td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr class="table-empty-row">
                  <td colspan="7" class="table-empty-cell">
                    <div class="empty-state">
                      <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                      <p class="empty-message">No active projects found</p>
                      <p class="empty-description">Try adjusting filters or check project setup</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </section>
      </div>
    }
  </div>
</div>
